export default __webpack_public_path__ + "assets/icons/fr.ac21de62.svg";